import { Controller } from "@hotwired/stimulus";

const GAP = 8;

// Positions the details popover of a calendar item next to the item it belongs
// to. The popover itself is opened and light-dismissed by the browser through
// `popovertarget`; it renders in the top layer, so it needs viewport
// coordinates rather than a position inside the calendar grid.
export default class extends Controller {
  static targets = ["trigger", "details"];

  connect() {
    this.position = this.position.bind(this);
    this.handleToggle = this.handleToggle.bind(this);

    this.detailsTarget.addEventListener("toggle", this.handleToggle);
  }

  disconnect() {
    this.detailsTarget.removeEventListener("toggle", this.handleToggle);
    this.stopTrackingViewport();
  }

  handleToggle(event) {
    if (event.newState === "open") {
      this.position();
      this.startTrackingViewport();
    } else {
      this.stopTrackingViewport();
    }
  }

  position() {
    const triggerRect = this.triggerTarget.getBoundingClientRect();
    const detailsRect = this.detailsTarget.getBoundingClientRect();

    // Prefer the right of the item, like a calendar event popover, and flip to
    // the left when the last days of the week would push it off screen.
    let left = triggerRect.right + GAP;
    if (left + detailsRect.width > window.innerWidth - GAP) {
      left = triggerRect.left - detailsRect.width - GAP;
    }
    left = Math.max(GAP, Math.min(left, window.innerWidth - detailsRect.width - GAP));

    const maxTop = Math.max(GAP, window.innerHeight - detailsRect.height - GAP);
    const top = Math.max(GAP, Math.min(triggerRect.top, maxTop));

    this.detailsTarget.style.left = `${left}px`;
    this.detailsTarget.style.top = `${top}px`;
  }

  startTrackingViewport() {
    window.addEventListener("scroll", this.position, true);
    window.addEventListener("resize", this.position);
  }

  stopTrackingViewport() {
    window.removeEventListener("scroll", this.position, true);
    window.removeEventListener("resize", this.position);
  }
}
